import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import HintTile from './HintTile'
import type { Hint } from './types'

const StyledHintContainer = styled.div`
  grid-area: 2 / 1 / 5 / 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  gap: 1rem;
  height: 100%;
  width: 10rem;
  
  @media (max-width: 480px) {
    grid-area: 3;
  }

  h3 {
    font-size: 1rem;
    margin: 0;
    color: white;

    @media (max-width: 480px) {
      font-size: .75rem;
    }

    @media (max-width: 320px) {
      font-size: .5rem;
    }
  }
`

const HintBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1rem;
  background-color: #CC0000;
  border-radius: 5px;
  border: 1px solid black;
  color: #333;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);
  width: calc(100% - 2rem);
`

interface HintContainerProps {
  hints: Hint[]
}

const HintContainer = ({ hints }: HintContainerProps): JSX.Element => {
  return (
        <StyledHintContainer>
          <HintBox>
          <h3>Hints</h3>
            {hints.map(({ group, answer }, index) => {
              return (
                <HintTile key={index} group={group} answer={answer} />
              )
            }
            )}
          </HintBox>
        </StyledHintContainer>
  )
}

HintContainer.propTypes = {
  hints: PropTypes.array.isRequired
}

export default HintContainer
